import React from 'react'
import { OpportunityInvestmentProjectionChartProps, ProjectionTooltipPoint } from '../../lib/types'
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { formatCompactCurrency, projectionRangeFilters } from './opportunity-detail.utils'
import ProjectionTooltip from './opportunity-detail-investment-projection-chart-tooltip'

const OpportunityInvestmentProjectionChart = ({
  currencyCode,
  filteredProjectionSeries,
  onRangeChange,
  selectedRange,
  startingAmount,
}: OpportunityInvestmentProjectionChartProps) => (
  <div className='opportunity-investment-projection-chart'>
    <div className='opportunity-investment-projection-chart-head'>
      <div className='opportunity-investment-projection-chart-head-main' />
      <div className='opportunity-investment-projection-filters'>
        {projectionRangeFilters.map((filter) => (
          <button
            key={filter.value}
            type='button'
            className={selectedRange === filter.value ? 'active' : ''}
            onClick={() => onRangeChange(filter.value)}
          >
            {filter.text}
          </button>
        ))}
      </div>
    </div>

    <div className='opportunity-investment-projection-chart-wrap'>
      <ResponsiveContainer width='100%' height={280}>
        <AreaChart
          data={filteredProjectionSeries}
          margin={{ left: 8, right: 12, top: 8, bottom: 6 }}
        >
          <defs>
            <linearGradient id='projectionFill' x1='0' y1='0' x2='0' y2='1'>
              <stop offset='5%' stopColor='#0D86FF' stopOpacity={0.35} />
              <stop offset='95%' stopColor='#0D86FF' stopOpacity={0.04} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray='3 3' vertical={false} />
          <XAxis
            dataKey='label'
            tick={{ fontSize: 12, fill: '#63768b' }}
            tickLine={false}
            axisLine={false}
            minTickGap={24}
            tickMargin={10}
          />
          <YAxis
            width={55}
            tick={{ fontSize: 12, fill: '#63768b' }}
            tickLine={false}
            axisLine={false}
            tickMargin={10}
            tickFormatter={(value) => formatCompactCurrency(Number(value), currencyCode)}
          />
          <Tooltip
            wrapperClassName='opportunity-investment-projection-tooltip-wrap'
            content={(tooltipProps) => (
              <ProjectionTooltip
                active={tooltipProps.active}
                payload={
                  tooltipProps.payload as
                    | ReadonlyArray<{ payload?: ProjectionTooltipPoint }>
                    | undefined
                }
                currencyCode={currencyCode}
                startingAmount={startingAmount}
              />
            )}
          />
          <Area
            type='monotone'
            dataKey='value'
            stroke='#0D86FF'
            fill='url(#projectionFill)'
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>
)

export default OpportunityInvestmentProjectionChart
